import e from"./_getNative.js";var t=e(Object,"create");export{t as default};
//# sourceMappingURL=_nativeCreate.js.map
